import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Button, Text, Box } from '@components/common';
import { Page, LandingContainer } from '@containers/layout';
import Logo from '@components/Logo';
import history from '@utils/history';

import SignupActions, { SIGNUP_STAGE } from '@redux/SignupRedux';

const StyledBox = styled(Box)`
  max-width: 320px;
`;

function WelcomePage(props) {
  const { clearSignup } = props;
  useEffect(() => {
    clearSignup();
  }, []);

  return (
    <Page>
      <LandingContainer
        flex={[1, 0]}
        display="flex"
        flexDirection="column"
        justifyContent="center"
      >
        <StyledBox
          flex={[1, 0]}
          mb={5}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <Logo />
          <Text fontSize={1} px={2} textAlign="center" mt={6}>
            You’ve done that piece of housekeeping, so now let’s book one of
            your own.
          </Text>
        </StyledBox>
        <Button
          mb={4}
          onClick={() => {
            history.push('/book');
          }}
        >
          Get started
        </Button>
      </LandingContainer>
    </Page>
  );
}

WelcomePage.propTypes = {
  clearSignup: PropTypes.func
};

const mapDispatchToProps = dispatch => ({
  clearSignup: () => dispatch(SignupActions.setSignupStep(SIGNUP_STAGE.EMAIL))
});

export default connect(
  null,
  mapDispatchToProps
)(WelcomePage);
